import { render } from "./order_summary.vue?vue&type=template&id=8470f8cc"
import script from "./order_summary.vue?vue&type=script&lang=js"
export * from "./order_summary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__